import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext(0);

export const AuthProvider = ({ children }) => {
    
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    useEffect(() => {
        const oData = localStorage.getItem('userInfo');        
        if (JSON.parse(oData)) {
            setIsAuthenticated(true);
        }
    }, [isAuthenticated]);

    const setAuth = (oData) => {
        localStorage.setItem('userInfo', JSON.stringify(oData));
        setIsAuthenticated(true);
    };

    const clearAuth = () => {
        localStorage.removeItem('userInfo');
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, setAuth, clearAuth }}>
            {children}
        </AuthContext.Provider>
    );
};
